// src/features/chat/components/his/ReplyChips.jsx
/*
 * Replies — the live turn's exits. Chips appear under the latest assistant
 * turn only (the conversational frontier); when the conversation moves on,
 * they vanish. Dimmed while the assistant is thinking. The displayed set is
 * frozen per anchor — no churn while in view.
 */

import React, { useEffect, useRef, useState } from 'react';
import styles from './ReplyChips.module.css';

export function ReplyChips({
  anchorId,
  primitives = [],
  dimmed = false,
  disabled = false,
  onSelect,
}) {
  const [displayed, setDisplayed] = useState([]);
  const displayedAnchorRef = useRef(null);
  const primitivesRef = useRef(primitives);
  primitivesRef.current = primitives;

  useEffect(() => {
    if (!anchorId) {
      displayedAnchorRef.current = null;
      setDisplayed([]);
      return;
    }
    if (displayedAnchorRef.current !== anchorId) {
      displayedAnchorRef.current = anchorId;
      setDisplayed(primitivesRef.current);
      return;
    }
    // Same anchor: adopt only when nothing is in view yet (not churn).
    if (primitives.length > 0) {
      setDisplayed((current) => (current.length === 0 ? primitives : current));
    }
  }, [anchorId, primitives]);

  if (!anchorId || displayed.length === 0) return null;

  return (
    <div className={styles.row} data-dimmed={dimmed ? 'true' : 'false'}>
      <div className={styles.list} role="group" aria-label="Suggested replies">
        {displayed.map((primitive) => (
          <button
            key={primitive.id}
            type="button"
            className={styles.chip}
            onClick={() => onSelect?.(primitive)}
            disabled={disabled || dimmed}
          >
            {primitive.userMessageText}
          </button>
        ))}
      </div>
    </div>
  );
}

export default ReplyChips;
